// Generated by genversion.
export const version = '2.52.0'
